import React, { useContext } from 'react';
import 'prop-types';
import ThemeContext from '../../ThemeProvider/context.js';
import styles from './styles.js';

const List = props => {
  const theme = useContext(ThemeContext);
  const classes = styles({
    theme,
    ...props
  });
  return /*#__PURE__*/React.createElement(props.tag, {
    className: `${classes.List} ${classes.Type}`,
    style: props.style
  }, props.children);
};
List.defaultProps = {
  tag: 'ul',
  position: 'outside',
  listType: 'disc',
  indent: 'sm'
};

export { List as default };
